import type { CFilesToDownloadTranslations } from "./pl";

/**
 * CFilesToDownload - English translations (Files to download).
 */
export const en: CFilesToDownloadTranslations = {
  emptyData: "No data to display.",
  emptyList: "No files in this section.",
  categoryLabel: "Category",
  allCategories: "All categories",
  back: "<- Back",
  download: "Download file",
  requiresLogin: "Logged-in users only",
  requiresAdmin: "Administrators only",
  fileFallbackExt: "FILE",
  units: {
    kb: "KB",
    mb: "MB",
  },
};
